'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../../external/classnames/index.js');
var PropTypes = require('prop-types');
var MediaListItem = require('../MediaListItem/MediaListItem.js');
var slugify = require('../../../utilities/slugify.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

/**
 * A customizable component to display a podcast as a list item within the MediaList component
 *
 * @param {Object} props - The props object for the component.
 * @param {string} [props.airDate] - The day your episode became available to listeners.
 * @param {string} props.description - The summary of the podcast episode.
 * @param {string} props.embedCode - This is the embed code for the podcast player.
 * @param {number} props.episodeNumber - The episode number of the podcast.
 * @param {string} props.seasonNumber - The season number of the podcast.
 * @param {string} props.title - The title of the podcast.
 *
 * @example
 * //Defaults none
 * <MediaListItemPodcast airDate='November 7, 2023' description='Two ways to prevent a catastrophic asteroid impact.' embedCode='<iframe height="200px" width="100%" frameborder="no" scrolling="no" title="Podcast Player" seamless src="https://player.simplecast.com/095d11b8-6ba1-40a0-8317-5da5fbec6361?dark=false"></iframe>' episodeNumber={1} seasonNumber='S2' title='How to Save the World'/>
 *
 * @returns {JSX.Element} The rendered Media List Podcast Item.
 */

var MediaListItemPodcast = function MediaListItemPodcast(props) {
  var airDate = props.airDate,
    description = props.description,
    embedCode = props.embedCode,
    episodeNumber = props.episodeNumber,
    seasonNumber = props.seasonNumber,
    title = props.title;
  var classes = index.default('lanl-media-list-item-podcast');
  return /*#__PURE__*/React__default.default.createElement(MediaListItem.MediaListItem, {
    className: classes,
    standard: false
  }, /*#__PURE__*/React__default.default.createElement("div", {
    className: "podcast-list",
    id: slugify.slugify(title)
  }, /*#__PURE__*/React__default.default.createElement("p", {
    className: "sidebar-title episode"
  }, seasonNumber, " : E", episodeNumber, airDate && " | ".concat(airDate)), /*#__PURE__*/React__default.default.createElement("h4", {
    className: "title"
  }, title), /*#__PURE__*/React__default.default.createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: description || ''
    }
  }), /*#__PURE__*/React__default.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: embedCode || ''
    }
  })));
};
MediaListItemPodcast.defaultProps = {};
MediaListItemPodcast.propTypes = {
  description: PropTypes__default.default.string.isRequired,
  embedCode: PropTypes__default.default.string.isRequired,
  episodeNumber: PropTypes__default.default.number.isRequired,
  seasonNumber: PropTypes__default.default.string.isRequired,
  title: PropTypes__default.default.string.isRequired,
  airDate: PropTypes__default.default.string
};

exports.MediaListItemPodcast = MediaListItemPodcast;
exports.default = MediaListItemPodcast;
//# sourceMappingURL=MediaListItemPodcast.js.map
